import { useLocation } from "react-router-dom";
import React, { useState } from "react";
export default function useRouterQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
